// extracted by mini-css-extract-plugin
module.exports = {"twoInput":"Steps_twoInput__2Uvlu","inputStyle":"Steps_inputStyle__2338I"};